<script>
  import copy from 'clipboard-copy';

  import { Tag } from 'carbon-components-svelte';
  import Copy from 'carbon-icons-svelte/lib/Copy16';

  export let label,
    value = null,
    color = null,
    withCopyButton = true;
</script>

<div class="double-tag">
  <Tag type={color}>
    <strong class="label">{label}</strong>
    <div class="value">
      <slot>{value}</slot>
    </div>
    {#if withCopyButton}
      <button type="button" class="bx--tag__close-icon" title="Copy" on:click={() => copy(value)}>
        <Copy />
      </button>
    {/if}
  </Tag>
</div>

<style>
  .double-tag {
    display: inline-block;
    user-select: none;
  }

  .double-tag :global(.bx--tag) {
    padding: 0;
  }

  .double-tag :global(.bx--tag > span) {
    display: flex;
    align-items: center;
    white-space: nowrap;
  }

  .double-tag :global(svg) {
    width: 12px;
    height: 12px;
  }

  .value {
    display: flex;
    align-items: center;
    gap: 0.3rem;
    margin: 0 0.3rem;
  }

  .label {
    background-color: rgba(176, 171, 202, 0.4);
    border-radius: 0.9375rem;
    padding: 0.35rem 0.5rem;
    font-size: 0.85em;
    white-space: nowrap;
  }
</style>
